export default __webpack_public_path__ + "static/media/strategyEng3.2f2fa5af.jpg";